export const handleAccordionExpand =
    (panel: number, setExpanded: (panel: number | false) => void) =>
    (open: boolean): void => {
        setExpanded(open ? panel : false)
    }
